import React, { forwardRef, useContext, useMemo } from 'react';
import { TableContext, TableHeader } from '@eas/common-web';

export const DecisionTableHeader = forwardRef<HTMLDivElement>(
  function DecisionTableHeader(_, ref) {
    const context = useContext(TableContext);

    const visibleDatakeys = useMemo(
      () => new Set(context.filteredColumns.map((column) => column.datakey)),
      [context.filteredColumns]
    );

    const headerContext = useMemo(
      () => ({
        ...context,
        sorts: context.sorts.filter(
          (sort) =>
            sort.datakey !== undefined && visibleDatakeys.has(sort.datakey)
        ),
      }),
      [context, visibleDatakeys]
    );

    return (
      <TableContext.Provider value={headerContext}>
        <TableHeader ref={ref} />
      </TableContext.Provider>
    );
  }
);
